var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import classNames from 'classnames';
import { unwrapResult } from '@reduxjs/toolkit';
import Paper from '@material-ui/core/Paper/Paper';
import { Slide } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import { LOGIN_PRESS } from '~constants/cpa-message-codes';
import { getTopRanking, getTopRankingPoll, getTopRankingPollStop, resetTopRanking, saveProviderId, templateInfoSelector, useTopRankingDataSelector, } from '~slices/top-ranking';
import { isAuthenticatedSelector, isCookieAcceptedSelector, } from '~slices/auth';
import { HorizonGalleryWithPlaceholder, Slider } from '~molecules';
import { useAppDispatch } from '~store';
import { bpDataSelector, getBp } from '~slices/bp';
import { Button, FullscreenLoader, List } from '~atoms';
import { betslipDataSelector, connectSocket, disconnect, getFullBetslip, maxOddBetslipDataSelector, } from '~slices/betslip';
import { useFullHeight, useIsDesktop, useIsMobileDevise, usePlatofrmType, useStructuredSelector, } from '~hooks';
import { BPRegistration } from '~organisms';
import { MODALS, closeModal, openModal } from '~modals';
import { PLATFORMS, SLIDESHOW_TYPE, getTeasers, slideshowSelector, } from '~slices/teasers';
import { bsSelector } from '~slices/shortcut';
import { SPORT_EVENTS_SOCKET_PATH } from '~slices/events';
import { EmptyRankingIcon } from '~icons/emptyRanking';
import { changeHintState } from '~slices/hints';
import { selectIsMobileTopRankingHidden, setIsMobileTopRankingHidden, } from '~slices/view';
import { IS_DEV } from '~/config/env';
import { itemRenderer } from './components/item-renderer';
import { Header } from './components/Header';
import { TicketDetailsBar } from './components/TicketDetailsBar';
import { useStyles } from './topRanking.styles';
var WEBSOCKET = process.env.REACT_APP_BASE_WEBSOCKET || '';
var MAX_PAYOUT_KEY = 'max_payout';
var BP_BALANCE_KEY = 'bp_balance';
var MAX_ODD_KEY = 'max_odd';
var PURCHASE_METHOD = 'purchase_method';
var SORT_OPTIONS = [
    MAX_PAYOUT_KEY,
    BP_BALANCE_KEY,
    MAX_ODD_KEY,
    PURCHASE_METHOD,
];
var PAGE_SIZE = 5;
var SORT_FUNCTIONS = (_a = {},
    _a[BP_BALANCE_KEY] = function (a, b) {
        var _a, _b;
        return (((_a = b.offer.balance) !== null && _a !== void 0 ? _a : NaN) - ((_b = a.offer.balance) !== null && _b !== void 0 ? _b : NaN) ||
            b.offer.maxPayout - a.offer.maxPayout ||
            b.offer.maxEffOdds - a.offer.maxEffOdds);
    },
    _a[MAX_PAYOUT_KEY] = function (a, b) {
        return (b.offer.maxPayout - a.offer.maxPayout ||
            b.offer.maxEffOdds - a.offer.maxEffOdds);
    },
    _a[MAX_ODD_KEY] = function (a, b) {
        return b.offer.maxEffOdds - a.offer.maxEffOdds;
    },
    _a[PURCHASE_METHOD] = function (a, b) {
        if (b.offer.purchaseMethod > a.offer.purchaseMethod) {
            return 1;
        }
        if (b.offer.purchaseMethod < a.offer.purchaseMethod) {
            return -1;
        }
        return 0;
    },
    _a);
// TODO refactor component move sorting to the separate utils
var TopRanking = function () {
    var _a, _b;
    var _c, _d, _e;
    var _f = useState(PURCHASE_METHOD), sortOption = _f[0], setSortOption = _f[1];
    var _g = useStructuredSelector({
        bs: bsSelector,
        betslip: betslipDataSelector,
        templateInfo: templateInfoSelector,
        isAuthenticated: isAuthenticatedSelector,
        topRankingData: useTopRankingDataSelector,
        maxOdd: maxOddBetslipDataSelector,
        banners: function (state) { return slideshowSelector(state); },
        cookieAccepted: isCookieAcceptedSelector,
        isMobileTopRankingHidden: selectIsMobileTopRankingHidden,
        providers: bpDataSelector,
    }), bs = _g.bs, betslip = _g.betslip, _h = _g.templateInfo, requestId = _h.requestId, providerId = _h.providerId, isAuthenticated = _g.isAuthenticated, providers = _g.providers, _j = _g.topRankingData, list = _j.list, loading = _j.loading, maxOdd = _g.maxOdd, banners = _g.banners, cookieAccepted = _g.cookieAccepted, isMobileTopRankingHidden = _g.isMobileTopRankingHidden;
    var isDisplayAnonymousRankingList = process.env.ANONYMOUS_RANKING_LIST === 'true';
    var styles = useStyles();
    var platform = usePlatofrmType();
    var isDesktop = useIsDesktop();
    var savedRequestId = useRef();
    var _k = useState(PAGE_SIZE), pageSize = _k[0], setPageSize = _k[1];
    var t = useTranslation('bpList').t;
    var handleChange = function (option) {
        setSortOption(option);
        setPageSize(PAGE_SIZE);
    };
    var location = useLocation();
    var dispatch = useAppDispatch();
    var isMobile = useIsMobileDevise();
    var slideshowPlatform = usePlatofrmType();
    var height = useFullHeight();
    var isProvidersList = ((_c = list.rankingList) === null || _c === void 0 ? void 0 : _c.length) ||
        (!isAuthenticated &&
            isDisplayAnonymousRankingList &&
            ((_d = list.excludedOffers) === null || _d === void 0 ? void 0 : _d.length));
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (list.rankingList) {
            var methodName = ((_a = list.rankingList) === null || _a === void 0 ? void 0 : _a.length)
                ? 'view_cart'
                : 'empty_ranking';
            var items = (_c = (_b = betslip.to) === null || _b === void 0 ? void 0 : _b.evs) === null || _c === void 0 ? void 0 : _c.map(function (item, indx) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                var index = indx + 1;
                return {
                    item_name: "".concat((_a = item.c1) === null || _a === void 0 ? void 0 : _a.nm, " vs ").concat((_b = item.c2) === null || _b === void 0 ? void 0 : _b.nm, " [").concat(((_c = item.sl) === null || _c === void 0 ? void 0 : _c.sel) ? (_e = (_d = item.sl) === null || _d === void 0 ? void 0 : _d.sel[index]) === null || _e === void 0 ? void 0 : _e.na : '', " (").concat(((_f = item.sl) === null || _f === void 0 ? void 0 : _f.sel) ? (_j = (_h = (_g = item.sl) === null || _g === void 0 ? void 0 : _g.sel[index]) === null || _h === void 0 ? void 0 : _h.oc) === null || _j === void 0 ? void 0 : _j.na : '', ") ]"),
                    item_id: "".concat(item.id, " : ").concat(((_k = item.sl) === null || _k === void 0 ? void 0 : _k.sel) ? (_m = (_l = item.sl) === null || _l === void 0 ? void 0 : _l.sel[index]) === null || _m === void 0 ? void 0 : _m.key : ''),
                    item_brand: item === null || item === void 0 ? void 0 : item.sp,
                    item_category: item === null || item === void 0 ? void 0 : item.cn,
                    item_category2: item === null || item === void 0 ? void 0 : item.tn,
                    index: index,
                };
            });
            var params = ((_d = list.rankingList) === null || _d === void 0 ? void 0 : _d.length)
                ? {
                    currency: (_e = betslip === null || betslip === void 0 ? void 0 : betslip.to) === null || _e === void 0 ? void 0 : _e.cu,
                    value: (_f = betslip === null || betslip === void 0 ? void 0 : betslip.to) === null || _f === void 0 ? void 0 : _f.bw,
                    items: items,
                }
                : {};
            if (!IS_DEV) {
                ReactGA.event(methodName, params);
                ReactPixel.trackCustom(methodName, params);
            }
        }
    }, [list.rankingList]);
    useEffect(function () {
        if (i18next.language) {
            dispatch(getTeasers({
                language: i18next.language,
                pageName: 'ANY_PAGE',
                platformType: slideshowPlatform,
                slideshowType: SLIDESHOW_TYPE,
                teaserStatus: isAuthenticated ? 'LOGGED_IN' : 'ANONYMOUS',
            }));
        }
    }, [i18next.language, isMobile, isAuthenticated]);
    var redirectToSdk = function (template, pId) {
        var _a;
        if (isAuthenticated) {
            dispatch(saveProviderId({ providerId: pId, template: template }));
        }
        else if (cookieAccepted) {
            dispatch(openModal({
                modalName: MODALS.LOGIN_MODAL,
                modalProps: {
                    withRedirectToHome: false,
                    isOpen: true,
                    onClose: function () { return dispatch(closeModal({ key: MODALS.LOGIN_MODAL })); },
                },
            }));
        }
        else if (platform === PLATFORMS.CROSS_PLATFORM_MOBILE) {
            (_a = window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({ code: LOGIN_PRESS }));
        }
        else {
            dispatch(changeHintState({ isCookiesConsentHintEnabled: true }));
        }
    };
    var changePageSize = function () {
        setPageSize(function (state) { return state + PAGE_SIZE; });
    };
    useEffect(function () {
        dispatch(getFullBetslip())
            .then(unwrapResult)
            .then(function (payload) {
            dispatch(connectSocket({
                desktop: isDesktop,
                url: "".concat(WEBSOCKET).concat(SPORT_EVENTS_SOCKET_PATH, "betSlip"),
                langIso: i18next.language,
                betSlipId: payload.bs,
                eventsType: 'betSlip',
            }));
        });
        return function () {
            dispatch(disconnect());
            dispatch({ type: 'SOCKET_CLOSE', eventsType: 'betSlip' });
        };
    }, []);
    useEffect(function () {
        var tId;
        var shouldReopen = false;
        var handleVisibilityChange = function () {
            if (document.hidden) {
                tId = setTimeout(function () {
                    dispatch({ type: 'SOCKET_CLOSE', eventsType: 'betSlip' });
                    shouldReopen = true;
                }, Number(process.env.REACT_APP_SOCKET_BACKGROUND_CLOSE_TIME) * 1000);
            }
            else if (shouldReopen) {
                dispatch(connectSocket({
                    desktop: isDesktop,
                    url: "".concat(WEBSOCKET).concat(SPORT_EVENTS_SOCKET_PATH, "betSlip"),
                    langIso: i18next.language,
                    betSlipId: bs,
                    eventsType: 'betSlip',
                }));
                shouldReopen = false;
            }
            else {
                clearTimeout(tId);
            }
        };
        if (typeof document.addEventListener === 'undefined') {
            console.log('This page requires a browser, that supports the Page Visibility API.');
        }
        else {
            document.addEventListener('visibilitychange', handleVisibilityChange, false);
        }
        return function () {
            clearTimeout(tId);
            document.removeEventListener('visibilitychange', handleVisibilityChange, false);
        };
    }, []);
    useEffect(function () {
        if (maxOdd && !savedRequestId.current) {
            dispatch(getTopRanking({ maxOdd: maxOdd }))
                .then(unwrapResult)
                .then(function (res) {
                if (res.requestId) {
                    savedRequestId.current = res.requestId;
                    dispatch(getTopRankingPoll(res.requestId));
                }
            });
        }
    }, [maxOdd]);
    useEffect(function () {
        if (isAuthenticated && savedRequestId.current) {
            dispatch(getTopRankingPoll(savedRequestId.current));
        }
        dispatch(getBp(true));
        return function () {
            dispatch(getTopRankingPollStop());
        };
    }, [isAuthenticated]);
    useEffect(function () {
        return function () {
            dispatch(resetTopRanking());
            dispatch(getTopRankingPollStop());
        };
    }, []);
    useEffect(function () {
        var _a, _b, _c;
        if (loading === 'fulfilled' &&
            Array.isArray(list.rankingList) &&
            ((_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.isDeactivationProcess)) {
            var activePlaySessionProviderId = ((location === null || location === void 0 ? void 0 : location.state) || {}).activePlaySessionProviderId;
            dispatch(setIsMobileTopRankingHidden(true));
            redirectToSdk('play-session-deactivation', activePlaySessionProviderId);
        }
        else if (loading === 'fulfilled' &&
            Array.isArray(list.rankingList) &&
            ((_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.isFastPlay)) {
            var _d = (location === null || location === void 0 ? void 0 : location.state) || {}, _e = _d.wagerValue, wagerValue_1 = _e === void 0 ? 0 : _e, activePlaySessionProviderId = _d.activePlaySessionProviderId;
            window.history.replaceState({}, document.title);
            var item = list.rankingList
                .filter(function (item) {
                return (!!item.offer.balanceCurrency &&
                    item.offer.balance &&
                    item.offer.balance >= wagerValue_1);
            })
                .sort(SORT_FUNCTIONS[MAX_PAYOUT_KEY])[0];
            if (!item) {
                dispatch(openModal({
                    modalName: MODALS.FAST_PLAY_NOT_AVAILABLE_MODAL,
                    modalProps: {
                        closeButtonLabel: t('close'),
                        cancelVariant: 'contained',
                        fullWidth: true,
                        hugeButton: true,
                        cancelColor: 'primary',
                        columnDialog: false,
                    },
                }));
                return;
            }
            if (item && !providerId) {
                dispatch(setIsMobileTopRankingHidden(true));
                var id = activePlaySessionProviderId && !isNaN(activePlaySessionProviderId)
                    ? activePlaySessionProviderId
                    : (_c = item.offer) === null || _c === void 0 ? void 0 : _c.providerId;
                redirectToSdk('purchase-ticket', id);
            }
        }
    }, [loading]);
    if (loading === 'pending') {
        return React.createElement(FullscreenLoader, null);
    }
    if (loading === 'fulfilled' && Array.isArray(list.rankingList)) {
        var items_1 = list.rankingList
            .slice()
            .sort(SORT_FUNCTIONS[sortOption])
            .slice(0, pageSize);
        if (!isAuthenticated && isDisplayAnonymousRankingList) {
            (_e = list.excludedOffers) === null || _e === void 0 ? void 0 : _e.map(function (excludedItem) {
                var _a;
                var withCurrentId = (_a = providers.responseObject) === null || _a === void 0 ? void 0 : _a.filter(function (provider) { return provider['id'] === excludedItem['providerId']; });
                if (withCurrentId) {
                    items_1.push({
                        topIndex: NaN,
                        offer: __assign(__assign({}, excludedItem), withCurrentId[0]),
                    });
                }
            });
        }
        return (React.createElement(React.Fragment, null,
            !isDesktop &&
                isMobileTopRankingHidden &&
                (!requestId || !providerId) && React.createElement(FullscreenLoader, null),
            React.createElement("div", { className: classNames({
                    'flex-column flex-scroll': isDesktop,
                }), style: !!requestId && !!providerId
                    ? {
                        overflow: 'hidden',
                        height: height ? "".concat(height - 52, "px") : 'calc(100vh - 52px)',
                    }
                    : undefined },
                React.createElement(HorizonGalleryWithPlaceholder, { className: classNames((_a = {},
                        _a[styles.hide] = !isDesktop && isMobileTopRankingHidden,
                        _a)) }),
                React.createElement("div", { style: { overflowX: 'hidden' }, className: classNames('flex-scroll', (_b = {},
                        _b[styles.hide] = !isDesktop && isMobileTopRankingHidden,
                        _b)) },
                    !isDesktop && React.createElement(TicketDetailsBar, null),
                    React.createElement(Header, { sortOptions: SORT_OPTIONS, selectedOption: sortOption, maxOdd: maxOdd || 0, handleChange: handleChange }),
                    isProvidersList ? (React.createElement(List, { redirectToSdk: redirectToSdk, selectedProviderId: providerId, items: items_1, renderItem: itemRenderer, className: isDesktop ? styles.listWrapper : undefined }, pageSize < list.rankingList.length ? (React.createElement(Button, { className: styles.showMoreButton, fullWidth: true, onClick: changePageSize },
                        React.createElement("span", { className: styles.showMoreButtonIcon },
                            React.createElement("i", { className: "fas fa-plus" })),
                        t('show_more'))) : null)) : (React.createElement("div", { className: classNames(styles.emptyState, {
                            mobile: !isDesktop,
                        }) },
                        React.createElement(EmptyRankingIcon, { className: classNames(styles.emptyStateIcon, {
                                mobile: !isDesktop,
                            }), width: isDesktop ? 220 : 120, height: isDesktop ? 220 : 120 }),
                        React.createElement("span", { className: classNames(styles.emptyStateTitle, {
                                mobile: !isDesktop,
                            }) }, t('empty_ranking_title')),
                        React.createElement("span", null, t('empty_ranking_subtitle')))),
                    React.createElement("div", { className: styles.banners }, Array.isArray(banners) && Boolean(banners.length) && (React.createElement(React.Fragment, null,
                        React.createElement(Slider, { position: "BOTTOM_1", slideshows: banners }),
                        React.createElement(Slider, { position: "BOTTOM_2", slideshows: banners }),
                        React.createElement(Slider, { position: "BOTTOM_3", slideshows: banners }),
                        React.createElement(Slider, { position: "BOTTOM_4", slideshows: banners }),
                        React.createElement(Slider, { position: "BOTTOM_5", slideshows: banners }))))),
                !isDesktop && (React.createElement(Slide, { direction: "up", in: !!requestId && !!providerId, mountOnEnter: true, unmountOnExit: true, timeout: 500 },
                    React.createElement(Paper, { elevation: 4, className: styles.paper, style: {
                            height: height ? "".concat(height - 50, "px") : 'calc(100vh - 50px)',
                        }, classes: { rounded: styles.rounded } },
                        React.createElement(BPRegistration, null)))))));
    }
    return null;
};
export default TopRanking;
